module.exports = __webpack_public_path__ + "img/flora_skincareoil.c1b36c69.jpg";